<template>
    <ProjectList    :name="$t('layout.navigation.favorites')"
                    :projectItems="projectItems"
                    :isSingleRow="false"
                    :isFavoriteInline="false"
                    :loading="isInitialLoad ? isLoading : false"
                    :error="isError"
                    @retry="() => fetchProjectItems(store.getters.getSessionId)">

    </ProjectList>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { animationAPI } from '@/services/api';
import ProjectList from '@/components/ProjectList.vue';

const store = useStore();
const router = useRouter();
const projectItems = ref([]);
const isLoading = ref(true);
const isError = ref(false);
const isInitialLoad = ref(true);

async function fetchProjectItems(sessionId) {
    if (isInitialLoad.value) {
        isLoading.value = true;
    }
    isError.value = false;

    try {
        const data = await animationAPI.getFavoriteAnimations(sessionId, router);
        projectItems.value = data;
    } catch (error) {
        console.error('Error fetching project items:', error);
        projectItems.value = [];
        isError.value = true;
    } finally {
        if (isInitialLoad.value) {
            isLoading.value = false;
            isInitialLoad.value = false;
        }
    }
}

onMounted(() => {
    const sessionId = store.getters.getSessionId;
    fetchProjectItems(sessionId);
});

</script>

<style scoped>
/* All styles are handled by ProjectList component */
</style>
